import React from 'react';
import * as PropTypes from 'prop-types';
import styled from 'styled-components';
import {CaretIcon} from '../../../icons/caret-icon';

const StepButtonStyle = styled.div`
	width: 30px;
	height: 30px;
	border: ${({theme}) => `1px solid ${theme.border.primary}`};
	background-color: ${({enabled, theme}) => (enabled ? theme.background.primary : theme.background.secondary)};
	cursor: ${({enabled}) => (enabled ? 'pointer' : 'normal')};
	display: flex;
	align-content: center;
	justify-content: center;
`;

export const StepButton = ({direction, onClick, enabled, userpilot, cy}) => {
	const iconDirection = direction === 'back' ? CaretIcon.DIRECTION.LEFT : CaretIcon.DIRECTION.RIGHT;

	return (
		<StepButtonStyle onClick={onClick} enabled={enabled} data-userpilot={userpilot} data-cy={cy}>
			<CaretIcon direction={iconDirection} size={CaretIcon.SIZE.STANDARD} color={enabled ? '#4C4C58' : '#A5A5AE'} />
		</StepButtonStyle>
	);
};

StepButton.propTypes = {
	direction: PropTypes.oneOf(['back', 'forward']).isRequired,
	enabled: PropTypes.bool.isRequired,
	onClick: PropTypes.func,
	/**
	 * ID needed for on-boarding tool
	 */
	userpilot: PropTypes.string,
	/**
	 * ID needed for Cypress testing
	 */
	cy: PropTypes.string,
};
